<template>
  <div>
    <a-dropdown :trigger="['click']" :getPopupContainer="triggerNode => triggerNode.parentNode" placement="bottomRight" :visible="visible" @visibleChange="visibleChange">
      <div class="trigger d-flex align-items-center justify-content-center">
        <a-avatar style="color: #fff;" class="primary-color-bg">{{ firstNameWord }}</a-avatar>
        <span class="ml-2 text-truncate" style="max-width: 100px;">{{ mobile }}</span>
      </div>
      <a-menu slot="overlay" @click="menuClick" v-if="scope === 'system'">
        <a-menu-item key="userInfo">{{ $t('scope.text_2') }}</a-menu-item>
        <a-menu-item key="logout">{{ $t('scope.text_6') }}</a-menu-item>
      </a-menu>
      <div slot="overlay" class="account-info-wrapper" v-else>
        <div class="account-info-wrapper-header">
          <div class="menu-item">
            <a-avatar class="account-info-wrapper-header-avatar">{{ firstNameWord }}</a-avatar>
          </div>
          <div class="menu-item">
            <p class="account-name text-center" style="margin-top:16px">{{ username }}</p>
            <p class="company-name text-center">{{ enterpriseInfo.name }}</p>
          </div>
        </div>
        <div class="d-flex menu-wrapper">
          <div class="menu-item p-2 flex-fill" @click="userMenuClick('userInfo')">
            <a-icon class="mr-2 ml-2" type="user" />
            {{$t('scope.text_2')}}</div>
          <!--隐藏企业信息div class="menu-item p-2 flex-fill text-center" @click="userMenuClick('companyInfo')" v-if="!isAdminMode">{{$t('scope.text_311')}}</div-->
          <div class="menu-item p-2 flex-fill text-center" @click="userMenuClick('accountCenter')">{{$t('scope.text_312')}}</div>
        </div>
        <div class="menu-wrapper">
          <div class="menu-item p-2" style="position: relative">
            <a-popover trigger="click" placement="left" :getPopupContainer="triggerNode => triggerNode.parentNode">
              <template slot="content">
                <theme-setting />
              </template>
              <icon class="mr-2 ml-2" type="theme-setting" />{{$t('common_629')}}
            </a-popover>
          </div>
          <div class="menu-item p-2" style="position: relative">
            <a-popover trigger="click" placement="left" :getPopupContainer="triggerNode => triggerNode.parentNode">
              <template slot="content">
                <div @click="settingLanguageCH">
                  <span class="mr-2" style="cursor: pointer">简体中文</span><a-icon v-show="language === 'zh-CN'" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                </div>
                <div @click="settingLanguageEN">
                  <span class="mr-2" style="cursor: pointer">English</span><a-icon v-show="language === 'en'" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                </div>
              </template>
              <a-icon class="mr-2 ml-2" type="global" />{{$t('common_630')}}
            </a-popover>
          </div>
          <div class="menu-item p-2" @click="userMenuClick('toClouduser')" v-if="showClouduser"><icon class="mr-2 ml-2" type="zizhanghao" />{{$t('scope.cloudid')}}</div>
          <div class="menu-item p-2" @click="userMenuClick('toCredentials')"><icon class="mr-2 ml-2" type="access-credentials" />{{$t('common_631')}}</div>
          <div class="menu-item p-2" @click="userMenuClick('handleUpdatePassword')" v-if="showUpdatePassword"><a-icon class="mr-2 ml-2" type="usergroup-delete" />{{$t('scope.text_5')}}</div>
         </div>
        <a-button class="logout" icon="logout" @click="userMenuClick('logout')">{{ $t('scope.text_6') }}</a-button>
      </div>
    </a-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ThemeSetting from '@/components/ThemeSetting'
import WindowsMixin from '@/mixins/windows'
import { genReferRouteQuery } from '@/utils/utils'
import { setLanguage } from '@/utils/common/cookie'
import { hasSetupKey } from '@/utils/auth'

export default {
  name: 'UserPopover',
  components: {
    ThemeSetting,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      enterpriseInfo: {},
      visible: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'scope', 'isAdminMode', 'setting']),
    ...mapState('app', {
      customer: state => state.customer,
      companyInfo: state => state.companyInfo,
    }),
    showUpdatePassword () {
      return !this.$store.getters.auth.is_sso
    },
    username () {
      return this.userInfo.displayname || this.userInfo.name
    },
    mobile () {
      return this.userInfo.mobile || this.username
    },
    firstNameWord () {
      const word = this.username.split('')[0]
      return word && word.toUpperCase()
    },
    language () {
      return this.setting.language
    },
    showClouduser () {
      return hasSetupKey(['public'])
    },
  },
  mounted () {
    this.manager = new this.$Manager('customers')
    this.fetchEnterPriseInfo()
  },
  methods: {
    async handleLogout () {
      try {
        await this.$store.dispatch('auth/logout')
        await this.$store.dispatch('common/deleteObject', {
          name: 'topAlert',
          key: 'createCloudAccounts',
        })
        this.$router.push({
          path: '/auth/login',
          query: genReferRouteQuery(this.$route),
        })
      } catch (error) {
        throw error
      }
    },
    handleUpdatePassword () {
      this.createDialog('UpdateUserPasswordDialog')
    },
    async menuClick (item) {
      if (item.key === 'logout') {
        try {
          await this.$store.dispatch('auth/logout')
          this.$router.push({
            path: '/auth/login',
            query: genReferRouteQuery(this.$route),
          })
        } catch (error) {
          throw error
        }
      } else if (item.key === 'userInfo') {
        this.$router.push('/user')
      }
    },
    userMenuClick (key) {
      this.visible = false
      if (key === 'logout') {
        this.handleLogout()
      } else if (key === 'userInfo') {
        this.$router.push('/user')
      } else if (key === 'companyInfo') {
        this.$router.push('/tenantCompanyInfo')
      } else if (key === 'handleUpdatePassword') {
        this.createDialog('UpdateUserPasswordDialog')
      } else if (key === 'toClouduser') {
        this.$router.push('/clouduser')
      } else if (key === 'accountCenter') {
        window.open('/account', '_blank')
      } else if (key === 'accessControl') {
        this.$router.push('/systemuser')
      } else if (key === 'toCredentials') {
        this.$router.push('/credentials')
      }
    },
    settingLanguageCH () {
      setLanguage('zh-CN')
      window.location.reload()
    },
    settingLanguageEN () {
      setLanguage('en')
      window.location.reload()
    },
    async fetchEnterPriseInfo () {
      const { data: { data = [] } } = await this.$store.dispatch('app/fetchCustomer')
      const { data: res } = await this.manager.getSpecific({ id: data[0].id, spec: 'enterprise-info' })
      this.enterpriseInfo = res
    },
    visibleChange (visible) {
      this.visible = visible
    },
  },
}
</script>

<style lang="less" scoped>
.trigger {
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
  text-decoration: none;
}
.account-info-wrapper {
  width: 250px;
  font-size: 16px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-color: rgba(0,0,0,.2);
  border-radius: 8px;
  box-shadow: 2px 2px 3px 2px #ccc;
  margin-right: 10px;
  .account-info-wrapper-header {
    margin-top: 20px;
    margin-bottom: 20px;
    .account-info-wrapper-header-avatar {
      width: 80px;
      height: 80px;
      color: #fff;
      font-size: 40px;
      line-height: 80px;
      display: block;
      background-color: #1890ff;
      margin: 0 auto;
    }
    .account-name {
      font-weight: 500;
      color: #202124;
      margin-bottom: 5px;
    }
    .company-name {
      color: #5f6368;
      font-size: 12px;
      margin-bottom: 0;
    }
  }
  .menu-wrapper {
    font-size: 14px;
    border-bottom: 1px solid #ccc;
    .menu-item {
      cursor: pointer;
    }
  }
  .logout {
    display: block;
    margin: 10px auto;
    border-radius: 5px;
  }
}
</style>
